import MemberEnrollmentForm from "../MemberEnrolements/MembershipEnrollmentForm";
import CreateCampaignReport from "../Reports/CampaignReport/createCampaignReport";
import CreatePointForfeitureReport from "../Reports/CreatePointsForfeitureReport";
import PointExpiryReport from "../Reports/CreatePointExpiryReport";
import PointLiabilityReport from "../Reports/PointLiabilityReport";
import GetRedemptionReport from "../Reports/RedeemptionReport";
import CreateMembersTransactionReport from "../Reports/CreateMembersTransactionReport";
import CallCenterReport from "../Reports/CallCenterReport";
import OtpReport from "../Reports/OtpReport";
import NewMemberEnrollmentForm from "../MemberEnrolements/NewMembershipEnrollmentForm";
import PointsExpiry from "../../pages/Pointsexpiry/Pointsexpiry";


  export const reportScreensMap = {
  "932": MemberEnrollmentForm,
  "864":CreateCampaignReport,
  "920":CreatePointForfeitureReport,
  "916":PointsExpiry,
  "896":PointLiabilityReport,
  "996":GetRedemptionReport,
  "908":CreateMembersTransactionReport,
  "948":CallCenterReport,
  "949":OtpReport,
  "950": NewMemberEnrollmentForm,

};